import type { Middleware } from '@reduxjs/toolkit';
import { PATH_AUTH_SPA } from '../../constants/spa-routes';
import { clearOnLogout } from 'src/utils/clear.util';
import { getErrorMessage } from 'src/utils/get-error-message';
import { useNotification } from 'src/hooks/useNotification';

export const unauthorizedMiddleware: Middleware = () => (next) => (action: unknown) => {
  const notification = useNotification();
  const act = action as { payload?: { status?: number; data?: { message?: string } } };

  if (act?.payload?.status === 401 && act?.payload?.data?.message === 'Unauthorized') {
    notification.error(getErrorMessage(act.payload));
    clearOnLogout();
    globalThis.location.assign(PATH_AUTH_SPA.ROOT);
  }

  return next(action);
};
